import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

const Hero: React.FC = () => {
  const [nameText, setNameText] = useState('');
  const [titleText, setTitleText] = useState('');
  const [currentNameIndex, setCurrentNameIndex] = useState(0);
  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);
  const [isTypingName, setIsTypingName] = useState(true);
  const [isPausing, setIsPausing] = useState(false);
  const [showCursor, setShowCursor] = useState(true);
  
  const fullName = 'Nick Marcuzzo';
  const fullTitle = 'Senior Software Engineer';
  
  useEffect(() => {
    if (isTypingName && currentNameIndex < fullName.length) {
      const timeout = setTimeout(() => {
        setNameText(fullName.slice(0, currentNameIndex + 1));
        setCurrentNameIndex(currentNameIndex + 1);
      }, 100);
      return () => clearTimeout(timeout);
    } else if (isTypingName && currentNameIndex >= fullName.length) {
      setIsPausing(true);
      setShowCursor(true);
      
      const initialDelay = setTimeout(() => {
        setShowCursor(false);
        
        const blinkInterval = setInterval(() => {
          setShowCursor(prev => !prev);
        }, 530);
        
        setTimeout(() => {
          clearInterval(blinkInterval);
          setShowCursor(true);
          setIsPausing(false);
          setIsTypingName(false);
        }, 1400);
        
      }, 200);
      
      return () => clearTimeout(initialDelay);
    } else if (!isTypingName && currentTitleIndex < fullTitle.length) {
      const timeout = setTimeout(() => {
        setTitleText(fullTitle.slice(0, currentTitleIndex + 1));
        setCurrentTitleIndex(currentTitleIndex + 1);
      }, 80);
      return () => clearTimeout(timeout);
    } else if (!isTypingName && currentTitleIndex >= fullTitle.length) {
      const initialDelay = setTimeout(() => {
        setShowCursor(false);
        
        setTimeout(() => setShowCursor(true), 500);
        setTimeout(() => setShowCursor(false), 1000);
        setTimeout(() => setShowCursor(true), 1500);
        setTimeout(() => setShowCursor(false), 2000);
        
      }, 200);
      
      return () => clearTimeout(initialDelay);
    }
  }, [currentNameIndex, currentTitleIndex, isTypingName, isPausing, fullName.length, fullTitle.length]);

  return (
    <section id="hero" className="min-vh-100 d-flex align-items-center">
      <Container>
        <Row className="align-items-center">
          <Col lg={5} className="text-center mb-5 mb-lg-0">
            <div className="profile-image mb-4">
              <div 
                className="profile-pic-container mx-auto" 
                style={{
                  width: '280px',
                  height: '280px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: '4px solid #30363d',
                  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)'
                }}
              >
                <img src="/assets/profile.jpg" alt="Nick Marcuzzo" className="img-fluid" />
              </div>
            </div>
          </Col>
          <Col lg={7}>
            <div className="text-center text-lg-start">
              <h1 className="display-2 fw-bold mb-3 hero-name">
                <span className={nameText ? 'text-visible' : 'text-placeholder'}>
                  {nameText || 'Nick Marcuzzo'}
                </span>
                {(isTypingName || isPausing) && (
                  <span 
                    className="typing-cursor-name"
                    style={{ opacity: isPausing ? (showCursor ? 1 : 0) : 1 }}
                  />
                )}
              </h1>
              <h2 className="display-5 text-muted mb-4 hero-title">
                <span className={titleText ? 'text-visible' : 'text-placeholder'}>
                  {titleText || 'Senior Software Engineer'}
                </span>
                {!isTypingName && showCursor && (
                  <span className="typing-cursor-title" />
                )}
              </h2>
              <p className="lead mb-5" style={{ maxWidth: '600px' }}>
                I build reliable applications and translate business needs into technical solutions, currently specializing in AI-powered tools.
              </p>              
              <div className="d-flex gap-3 justify-content-center justify-content-lg-start flex-wrap">
                <Button variant="primary" size="lg" href="#projects">
                  View My Work
                </Button>
                <Button variant="outline-light" size="lg" href="#contact">
                  Get In Touch
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
